import { render, staticRenderFns } from "./WorkflowFormBuilderOptionTabWindow.vue?vue&type=template&id=cdce674a&scoped=true&"
import script from "./WorkflowFormBuilderOptionTabWindow.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderOptionTabWindow.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderOptionTabWindow.vue?vue&type=style&index=0&id=cdce674a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce674a",
  null
  
)

export default component.exports